import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { searchAdminResource } from './api';
import type { AdminFilterResource, AdminSearchRequest } from './types';

export function useAdminSearch<T>(resource: AdminFilterResource, request: AdminSearchRequest) {
  return useQuery({
    queryKey: ['admin-search', resource, request],
    queryFn: () => searchAdminResource<T>(resource, request),
    placeholderData: keepPreviousData,
  });
}
